export const featuredArticles = [
  {
    id: 'bts-2026-comeback',
    title: 'BTS 2026 完整体回归！新专辑《WINGS OF DAWN》全球同步上线',
    category: '音乐',
    categorySlug: 'music',
    image: 'https://readdy.ai/api/search-image?query=Kpop%20boy%20band%20performing%20on%20stage%20with%20dramatic%20lighting%20and%20fog%20effects%2C%20artistic%20concert%20photography%2C%20warm%20golden%20and%20coral%20tones%2C%20soft%20gradient%20background%2C%20cinematic%20composition&width=800&height=450&seq=featured-01&orientation=landscape',
    excerpt: '时隔两年，BTS 以完整体重磅回归，新专辑融合电子与古典元素，首日即打破多项纪录...',
    date: '2026-08-08',
    author: '韩流观察员',
    readTime: '8分钟',
  },
  {
    id: 'japan-anime-summer-2026',
    title: '2026夏番日漫推荐：十部必追新番，京都动画新作领衔',
    category: '影视',
    categorySlug: 'drama',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20art%20style%20illustration%20with%20vibrant%20summer%20scenery%2C%20cherry%20blossom%20petals%2C%20warm%20sunlight%2C%20beautiful%20clouds%2C%20soft%20pastel%20color%20palette%2C%20cinematic%20anime%20background%20art&width=800&height=450&seq=featured-02&orientation=landscape',
    excerpt: '夏季新番盛宴来袭！从热血战斗到治愈日常，我们为你精选了十部不可错过的日漫新作...',
    date: '2026-08-07',
    author: '动漫编辑室',
    readTime: '12分钟',
  },
  {
    id: 'k-variety-earth-arcade-3',
    title: '《地球游乐厅3》重磅回归！原班人马再聚首，笑点密集升级',
    category: '综艺',
    categorySlug: 'variety',
    image: 'https://readdy.ai/api/search-image?query=Korean%20variety%20show%20set%20with%20colorful%20playful%20decorations%2C%20bright%20studio%20lighting%2C%20entertainment%20stage%20with%20game%20props%2C%20warm%20atmosphere%2C%20professional%20TV%20production%20photography&width=800&height=450&seq=featured-03&orientation=landscape',
    excerpt: '罗英锡PD操刀的现象级综艺第三季来了！原班人马李恩智、MIMI、李泳知、安宥真全员回归...',
    date: '2026-08-06',
    author: '综艺情报局',
    readTime: '6分钟',
  },
];

export const latestUpdates = [
  {
    id: 'twice-world-tour-seoul',
    title: 'TWICE 首尔演唱会座无虚席，世界巡演正式启程',
    category: '音乐',
    categorySlug: 'music',
    image: 'https://readdy.ai/api/search-image?query=Kpop%20girl%20group%20concert%20performance%20with%20cheering%20crowd%2C%20colorful%20stage%20lights%2C%20energetic%20atmosphere%2C%20professional%20concert%20photography%2C%20warm%20lighting&width=400&height=300&seq=latest-01&orientation=landscape',
    date: '2026-08-09',
  },
  {
    id: 'j-drama-first-love-2',
    title: '《First Love 初恋》第二季制作决定！满岛光×佐藤健再度携手',
    category: '影视',
    categorySlug: 'drama',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20romantic%20drama%20scene%20with%20snowy%20Hokkaido%20landscape%2C%20couple%20walking%20under%20street%20lamps%2C%20nostalgic%20atmosphere%2C%20cinematic%20warm%20lighting%2C%20emotional%20tone&width=400&height=300&seq=latest-02&orientation=landscape',
    date: '2026-08-09',
  },
  {
    id: 'running-man-700-episode',
    title: '《Running Man》700期特辑：历代最强嘉宾阵容齐聚',
    category: '综艺',
    categorySlug: 'variety',
    image: 'https://readdy.ai/api/search-image?query=Korean%20variety%20show%20Running%20Man%20cast%20group%20photo%2C%20colorful%20casual%20clothing%2C%20outdoor%20setting%2C%20bright%20sunny%20day%2C%20fun%20energetic%20vibe&width=400&height=300&seq=latest-03&orientation=landscape',
    date: '2026-08-08',
  },
  {
    id: 'japan-music-fes-2026',
    title: 'SUMMER SONIC 2026 完整阵容公布：YOASOBI、Official髭男dism领衔',
    category: '音乐',
    categorySlug: 'music',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20music%20festival%20outdoor%20stage%20with%20large%20crowd%2C%20summer%20atmosphere%2C%20colorful%20banners%2C%20blue%20sky%2C%20festival%20vibe%2C%20warm%20sunlight&width=400&height=300&seq=latest-04&orientation=landscape',
    date: '2026-08-08',
  },
  {
    id: 'k-drama-queen-of-tears-2',
    title: '《眼泪女王》确认制作第二季！金秀贤×金智媛有望再度合作',
    category: '影视',
    categorySlug: 'drama',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20scene%20with%20elegant%20couple%20in%20modern%20luxury%20setting%2C%20soft%20warm%20lighting%2C%20emotional%20atmosphere%2C%20cinematic%20composition&width=400&height=300&seq=latest-05&orientation=landscape',
    date: '2026-08-07',
  },
  {
    id: 'newjeans-tokyo-dome',
    title: 'NewJeans 东京巨蛋公演追加确定，日韩同步直播',
    category: '音乐',
    categorySlug: 'music',
    image: 'https://readdy.ai/api/search-image?query=Kpop%20girl%20group%20stage%20performance%20with%20dreamy%20pastel%20lighting%2C%20youthful%20vibrant%20concept%2C%20large%20venue%20atmosphere%2C%20professional%20photography&width=400&height=300&seq=latest-06&orientation=landscape',
    date: '2026-08-07',
  },
];

export const heroSlides = [
  {
    id: 'hero-01',
    title: '日韩内容 一站聚合',
    subtitle: '最新影视 · 热门音乐 · 爆笑综艺 · 深度资讯',
    description: '海量日韩正版资源，每日更新，无需翻墙，极速流畅播放',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20abstract%20geometric%20composition%20with%20warm%20coral%20red%20and%20golden%20amber%20gradients%2C%20smooth%20flowing%20shapes%2C%20elegant%20Japanese%20and%20Korean%20aesthetic%20fusion%2C%20clean%20artistic%20background%2C%20professional%20design%2C%20no%20text&width=1600&height=800&seq=hero-slide-01&orientation=landscape',
    ctaText: '立即探索',
    ctaLink: '/category',
  },
  {
    id: 'hero-02',
    title: '2026夏季日漫新番特辑',
    subtitle: '京都动画 · MAPPA · WIT STUDIO 齐聚今夏',
    description: '十部必追新番深度解析，这个夏天不再剧荒',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20illustration%20of%20summer%20sky%20with%20floating%20islands%20and%20cherry%20blossoms%2C%20warm%20golden%20sunlight%2C%20dreamy%20atmosphere%2C%20soft%20coral%20and%20amber%20color%20palette%2C%20cinematic%20anime%20art&width=1600&height=800&seq=hero-slide-02&orientation=landscape',
    ctaText: '查看专题',
    ctaLink: '/category',
  },
  {
    id: 'hero-03',
    title: '韩流演唱会资讯一站掌握',
    subtitle: 'BTS · BLACKPINK · TWICE · SEVENTEEN',
    description: '最新巡演日程、票务资讯、现场直击，不遗漏每一场精彩',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20concert%20stage%20with%20dramatic%20beam%20lights%20and%20crowd%20silhouettes%2C%20warm%20golden%20and%20coral%20color%20gradient%2C%20atmospheric%20fog%2C%20grand%20scale%2C%20professional%20music%20festival%20aesthetic&width=1600&height=800&seq=hero-slide-03&orientation=landscape',
    ctaText: '了解更多',
    ctaLink: '/category',
  },
];

export const categoryHighlights = [
  {
    id: 'drama',
    name: '影视',
    icon: 'ri-movie-2-line',
    description: '最新日韩电视剧、电影、动漫',
    color: 'bg-primary-500',
    count: '2,860+',
    link: '/category?tab=drama',
  },
  {
    id: 'music',
    name: '音乐',
    icon: 'ri-music-2-line',
    description: 'J-POP、K-POP、独立音乐',
    color: 'bg-accent-500',
    count: '5,420+',
    link: '/category?tab=music',
  },
  {
    id: 'variety',
    name: '综艺',
    icon: 'ri-emotion-laugh-line',
    description: '热门日韩综艺、真人秀',
    color: 'bg-secondary-500',
    count: '1,830+',
    link: '/category?tab=variety',
  },
  {
    id: 'news',
    name: '资讯',
    icon: 'ri-newspaper-line',
    description: '日韩娱乐最新动态速递',
    color: 'bg-primary-700',
    count: '12,600+',
    link: '/category?tab=news',
  },
];

export const stats = [
  { value: '50万+', label: '日活跃用户' },
  { value: '3万+', label: '正版内容资源' },
  { value: '99.9%', label: '播放流畅率' },
  { value: '24h', label: '内容更新周期' },
];